import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Button } from "./ui/button";
import { ExtrasEditor } from "./ExtrasEditor";
import { api } from "../lib/api";
import { cleanExtras, invoiceFromBooking } from "../lib/invoice";
import { useToast } from "../hooks/use-toast";

export const ExtrasDialog = ({ booking, onClose, onSaved }) => {
  const { toast } = useToast();
  const [extras, setExtras] = useState(booking.extras || []);
  const [saving, setSaving] = useState(false);
  const preview = invoiceFromBooking({ ...booking, extras });

  const save = async () => {
    if (extras.some((x) => !String(x.name || "").trim() && x.price !== "")) {
      toast({ title: "Extra charge needs a name", description: "Name each extra charge, or remove the empty row." });
      return;
    }
    setSaving(true);
    try {
      await api.updateExtras(booking.booking_id, cleanExtras(extras));
      toast({ title: "Charges updated", description: `New total: ${booking.currency} ${preview.total.toLocaleString("en-IN")}` });
      onSaved();
      onClose();
    } catch (e) {
      toast({ title: "Could not save charges", description: String(e.response?.data?.detail || e.message) });
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="extras-dialog" className="max-w-xl">
        <DialogHeader>
          <DialogTitle className="font-serif text-2xl">Extra charges · {booking.booking_id}</DialogTitle>
        </DialogHeader>
        <ExtrasEditor value={extras} onChange={setExtras} />
        <div className="flex items-center justify-between border-t border-neutral-200 pt-3 text-sm">
          <span>New total (incl. GST, rounded)</span>
          <span data-testid="extras-dialog-total" className="font-semibold">{booking.currency} {preview.total.toLocaleString("en-IN", { minimumFractionDigits: 2 })}</span>
        </div>
        <Button data-testid="extras-save-btn" disabled={saving} onClick={save} className="bg-[#c8102e] hover:bg-[#a70d26] text-white rounded-none">
          {saving ? "Saving…" : "Save charges"}
        </Button>
      </DialogContent>
    </Dialog>
  );
};
